import { render, staticRenderFns } from "./PlcCurtain_t.vue?vue&type=template&id=0c99bf8a&scoped=true"
import script from "./PlcCurtain_t.vue?vue&type=script&lang=js"
export * from "./PlcCurtain_t.vue?vue&type=script&lang=js"
import style0 from "./PlcCurtain_t.vue?vue&type=style&index=0&id=0c99bf8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c99bf8a",
  null
  
)

export default component.exports